export default "__VITE_ASSET__0aa8edee__"